import React from "react";

function useApiPetition() {
    const [responseApi, setResponseApi] = React.useState(null);
    const [responseSecondApi, setResponseSecondApi] = React.useState(null);
    const [error, setError] = React.useState(null);

    const postApi = async (url, data) => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            setResponseApi(responseData); 
            setError(null);

            console.log(responseData.data.result);

            if (responseData.data.result === 1) {
                await postSecondApi(url, data);
            }
        } catch (error) {
            console.error('Error send petition:', error);
            setResponseApi(null);
            setError(error);
        }
    };

    const postSecondApi = async (url, data) => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            setResponseSecondApi(responseData);
            setError(null);
        } catch (error) {
            console.error('Error send second petition:', error);
            setResponseSecondApi(null);
            setError(error);
        }
    };

    return {
        responseApi,
        responseSecondApi,
        error,
        postApi,
        postSecondApi,
    };
}

export { useApiPetition };
